<template>
  <main-template>
    <v-row>
      <v-col>
        <h1 :id="'titulo-planos-semestrais'">
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'home' })"
            :id="'btn-voltar-home'"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planos Semestrais
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-form :id="'form-pesquisa-avancada'">
          <v-card>
            <div class="text-start py-2 px-4 text-button" :id="'pesquisa-avancada-label'">
              Pesquisa avançada
            </div>

            <v-divider class="theme--light"></v-divider>
            <v-row class="px-4 mt-4">
              <v-col v-if="permitirRolesParaGestores() >= 0">
                <v-text-field
                  v-model="professor"
                  label="NOME ou CPF Professor"
                  outlined
                  dense
                  :id="'input-professor'"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-space-between mb-6 px-4">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="disciplinas"
                  :return-object="false"
                  v-model="disciplina"
                  label="Escolha uma disciplina"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                  :id="'autocomplete-disciplina'"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="turmas"
                  :return-object="false"
                  v-model="turma"
                  label="Escolha uma turma"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                  :id="'autocomplete-turma'"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="$constants.semestres"
                  :return-object="false"
                  v-model="semestre"
                  label="Escolha um semestre"
                  item-text="desc"
                  item-value="value"
                  outlined
                  dense
                  :id="'autocomplete-semestre'"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-5">
                <v-btn
                  color="primary"
                  block
                  @click="() => limparCampos()"
                  :id="'btn-limpar-filtros'"
                >
                  Limpar filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>

      <v-col>
        <v-data-table
          :loading="carregando"
          :headers="table.headers"
          :items="planos"
          :items-per-page="15"
          hide-default-footer
          class="elevation-1"
          :id="'tabela-planos'"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                v-for="plano of items"
                :key="plano.id"
                :id="`linha-plano-${plano.id}`"
              >
                <td :id="`coluna-id-plano-${plano.id}`">{{ plano.id ? plano.id : "- - -" }}</td>
                <td :id="`coluna-professor-plano-${plano.id}`">
                  {{ plano.gestao_de_aula.professor.nome }}
                </td>
                <td :id="`coluna-turma-plano-${plano.id}`">
                  {{ plano.gestao_de_aula.turma.descricao }}
                </td>
                <td :id="`coluna-status-plano-${plano.id}`">
                  <e-situacao-plano
                    :plano="plano"
                    @update="(e) => [carregarDadosAoAtualizarStatus(e)]"
                  />
                </td>

                <td :id="`coluna-semestre-plano-${plano.id}`">
                  {{ getSemestreDesc(plano.semestre) }}
                </td>
                <td :id="`coluna-disciplina-plano-${plano.id}`">
                  {{ plano.disciplina?.descricao }}
                </td>
                <td :id="`coluna-acoes-plano-${plano.id}`">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="
                          () =>
                            $router.push({
                              name: 'gestoesDeAulas.planosVisualizar',
                              params: { id: plano.id },
                            })
                        "
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="orange"
                        v-on="on"
                        :id="`btn-visualizar-plano-${plano.id}`"
                      >
                        <v-icon small>mdi-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="() => [visualizarPdf(plano.id), (dialog = true)]"
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="orange"
                        v-on="on"
                        :id="`btn-gerar-pdf-plano-${plano.id}`"
                      >
                        <v-icon small>mdi-note </v-icon>
                      </v-btn>
                    </template>
                    <span>Gerar PDF</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarPlanos"
          :search="search"
          :id="'paginacao-planos'"
        >
        </e-paginate>
      </v-col>
    </v-row>

    <EModalVisualizarPDFs
      :dialog="dialog"
      :pdf="pdf"
      v-on:update="carregarDadosAoAtualizarStatus"
    />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import EModalVisualizarPDFs from "@/components/EModalVisualizarPDFs.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    EModalVisualizarPDFs,
  },
  watch: {
    async professor(value) {
      value = this.formatarCPf(value);
      this.professor = value;
      await this.carregarPlanos();
    },
    async turma(value) {
      this.turma = value;
      await this.carregarPlanos();
    },
    async disciplina(value) {
      this.disciplina = value;
      await this.carregarPlanos();
    },
    async semestre(value) {
      this.semestre = value;
      await this.carregarPlanos();
    },
  },
  data() {
    return {
      carregando: false,
      dialog: false,
      pdf: null,
      disciplinas: [],
      semestres: [],
      meses: [],
      turmas: [],
      planos: [],
      descricaoDosSemestres: {
        1: "1° Semestre",
        2: "2° Semestre",
      },
      professor: "",
      turma: "",
      disciplina: "",
      semestre: "",
      dataTableFilter,
      search: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 1,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Professor", value: "gestao_de_aula.professor.nome" },
          { text: "Turma", value: "gestao_de_aula.turma.descricao" },
          { text: "Status", value: "status" },
          { text: "Semestre", value: "semestre" },
          { text: "Disciplina", value: "gestao_de_aula.disciplina.descricao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  async mounted() {
    this.carregarDados();
    this.permitirRolesParaGestores();
  },
  methods: {
    getSemestreDesc(id) {
      return this.$constants.semestres.find((semestre) => semestre.value === id)?.desc;
    },
    async carregarDados() {
      await this.carregarPlanos(this.pageNumber);
      await this.listarDisciplinas();
      await this.listarTurmas();
    },
    permitirRolesParaGestores() {
      try {
        const userLocal = this.user.roles ? this.user.roleName : [];
        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
    async listarDisciplinas() {
      try {
        const { data } = await this.$services.planosService.disciplinas();
        this.disciplinas = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarTurmas() {
      try {
        const { data } = await this.$services.planosService.turmas();
        const result = data.map((t) => {
          const local = { ...t };
          return (local.descricao = `${t.descricao} (${t.franquia.descricao})`);
        });
        this.turmas = result;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarPlanos(numeroDaPagina = null) {
      this.paginate.current_page = numeroDaPagina || this.pageNumber;
      this.pageNumber = numeroDaPagina || this.pageNumber;
      try {
        this.dialog = false;
        this.carregando = true;
        const payload = await this.$services.planosService.index(
          this.pageNumber,
          this.professor,
          this.turma,
          this.disciplina,
          this.semestre
        );
        this.planos = payload.planos;
        this.paginate = payload.data;
        this.carregando = false;
        this.pdf = null;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarDadosAoAtualizarStatus(plano) {
      try {
        await this.carregarPlanos();
      } catch (error) {
        this.$handleError(error);
      }
    },
    limparCampos() {
      this.professor = "";
      this.turma = "";
      this.disciplina = "";
      this.semestre = "";
    },
    formatarCPf(value) {
      value = value.replace("-", "");
      value = value.replace(".", "");
      return value;
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfSemestral(planoId);
    },
  },
};
</script>
<style></style>
